import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-select-icon-component',
  templateUrl: './select-icon-component.component.html',
  styleUrls: ['./select-icon-component.component.css']
})
export class SelectIconComponentComponent implements OnInit {

  @Input() appearance: 'fill' | 'outline' | 'standard' = 'standard';

  currentSelection: MaterialIcon;

  _preSelected: string;
  @Input() set preSelected(value: string) {
    this._preSelected = value;
    if (value) {
      let preSelected = MaterialIconsCollection.find(x => x.code == value);
      if (preSelected) this.currentSelection = preSelected;
      else this.currentSelection = null;
    }
    else this.currentSelection = null;
  }

  @Input() color: string;

  @Output() selectionChanged: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  setIcon(icon: MaterialIcon) {
    this.currentSelection = icon;
    this.selectionChanged.emit(icon.code);
  }

  get materialIconsCollection(): MaterialIcon[] {
    return MaterialIconsCollection;
  }

}

export const MaterialIconsCollection: MaterialIcon[] = [
  { code: "add" },
  { code: "router" },
  { code: "share" },
  { code: "clear" },
  { code: "menu" },
  { code: "bar_chart" },
  { code: "call" },
  { code: "wifi_calling" },
  { code: "3d_rotation" },
  { code: "account_balance" },
  { code: "add_shopping_cart" },
  { code: "anchor" },
  { code: "api" },
  { code: "commute" },
  { code: "contactless" },
  { code: "dns" },
  { code: "done" },
  { code: "extension" },
  { code: "face" },
  { code: "person" },
  { code: "sentiment_satisfied_alt" },
  { code: "supervised_user_circle" },
  { code: "fact_check" },
  { code: "favorite" },
  { code: "favorite_border" },
  { code: "event" },
  { code: "euro_symbol" },
  { code: "bug_report" },
  { code: "delete_forever" },
  { code: "filter_alt" },
  { code: "fingerprint" },
  { code: "home" },
  { code: "language" },
  { code: "launch" },
  { code: "history" },
  { code: "gif" },
  { code: "online_prediction" },
  { code: "power_settings_new" },
  { code: "quickreply" },
  { code: "settings" },
  { code: "shopping_cart" },
  { code: "support" },
  { code: "timeline" },
  { code: "thumb_up" },
  { code: "thumb_down" },
  { code: "theaters" },
  { code: "track_changes" },
  { code: "translate" },
  { code: "verified_user" },
  { code: "visibility" },
  { code: "visibility_off" },
  { code: "work" },
  { code: "work_outline" },
  { code: "zoom_in" },
  { code: "zoom_out" },
  { code: "gavel" },
  { code: "https" },
  { code: "http" },
  { code: "exit_to_app" },
  { code: "leaderboard" },
  { code: "view_carousel" },
  { code: "touch_app" },
  { code: "trending_down" },
  { code: "trending_flat" },
  { code: "trending_up" },
  { code: "mediation" },
  { code: "polymer" },
  { code: "rowing" },
  { code: "store" },
  { code: "verified" },
  { code: "backup_table" },
  { code: "card_giftcard" },
  { code: "eco" },
  { code: "airplanemode_active" },
  { code: "airplanemode_inactive" },
  { code: "flight_land" },
  { code: "flight_takeoff" },
  { code: "info" },
  { code: "lock" },
  { code: "lock_open" },
  { code: "movie" },
  { code: "play_arrow" },
  { code: "assessment" },
  { code: "flash_on" },
  { code: "speed" },
  { code: "videocam" },
  { code: "videocam_off" },
  { code: "volume_up" },
  { code: "volume_mute" },
  { code: "alternate_email" },
  { code: "business" },
  { code: "domain_disabled" },
  { code: "location_on" },
  { code: "dialer_sip" },
  { code: "nat" },
  { code: "qr_code" },
  { code: "qr_code_scanner" },
  { code: "voicemail" },
  { code: "swap_calls" },
  { code: "vpn_key" },
  { code: "biotech" },
  { code: "content_cut" },
  { code: "gesture" },
  { code: "insights" },
  { code: "how_to_vote" },
  { code: "report" },
  { code: "square_foot" },
  { code: "waves" },
  { code: "remove" },
  { code: "clear" },
  { code: "undo" },
  { code: "usb" },
  { code: "wifi_tethering" },
  { code: "nfc" },
  { code: "attach_file" },
  { code: "pets" },
  { code: "rule" },
  { code: "shop" },
  { code: "4k" },
  { code: "5g" },
  { code: "hearing" },
  { code: "loop" },
  { code: "pause" },
  { code: "contact_phone" },
  { code: "bluetooth" },
  { code: "bluetooth_disabled" },
  { code: "devices" },
  { code: "bubble_chart" },
  { code: "format_paint" },
  { code: "highlight" },
  { code: "score" },
  { code: "subscript" },
  { code: "superscript" },
  { code: "show_chart" },
  { code: "stacked_line_chart" },
  { code: "watch" },
  { code: "speaker" },
  { code: "bedtime" },
  { code: "camera" },
  { code: "audiotrack" },
  { code: "filter_drama" },
  { code: "electrical_services" },
  { code: "electric_car" },
  { code: "edit_road" },
  { code: "handyman" },
  { code: "hotel" },
  { code: "sports_rugby" },
  { code: "sports_motorsports" },
  { code: "whatshot" },
  { code: "science" },
  { code: "school" },
  { code: "sports_cricket" },
  { code: "sports_golf" },
  { code: "sports_volleyball" },
  { code: "sports" }
];

export class MaterialIcon {
  code: string;
}
